module.exports = __webpack_public_path__ + "img/tool4.cbe276b7.png";